import { AccountSettingsItems } from "@components/mainInterface/UserDropdown/AccountSettingsItems";
import { SettingsDropdownItem } from "@components/mainInterface/UserDropdown/SettingsDropdownItem";
import { Menu } from "@design-system/Menu/Menu.lib";
import { OrganizationSettingsPages } from "@components/settings/constants";
import { useCanPerformOrganizationAction } from "@hooks/permissions/organization/useCanPerformOrganizationAction";
import { OrganizationAction } from "@common/userOrganizationRoles";
import { useTypedFlags } from "@hooks/useTypedFlags";

export const OrganizationViewUserDropdownItems: React.FC = () => {
    const canManageOrganizationSettings = useCanPerformOrganizationAction(
        OrganizationAction.MANAGE_ORGANIZATION_SETTINGS,
    );
    const { closeManagement } = useTypedFlags();

    return (
        <>
            <AccountSettingsItems />

            {canManageOrganizationSettings && (
                <>
                    <Menu.Separator />
                    <Menu.Group>
                        <Menu.GroupLabel>Firm</Menu.GroupLabel>
                        <SettingsDropdownItem
                            path={OrganizationSettingsPages.FIRM_INFORMATION}
                        >
                            Profile
                        </SettingsDropdownItem>
                        <SettingsDropdownItem
                            path={OrganizationSettingsPages.TASK_GROUPS}
                        >
                            Task groups
                        </SettingsDropdownItem>
                        {closeManagement && (
                            <SettingsDropdownItem
                                path={OrganizationSettingsPages.CLOSES}
                            >
                                Service templates
                            </SettingsDropdownItem>
                        )}
                    </Menu.Group>
                </>
            )}
        </>
    );
};
